import { render, staticRenderFns } from "./JwJiaocaiOrderSelectJc.vue?vue&type=template&id=271b245e"
import script from "./JwJiaocaiOrderSelectJc.vue?vue&type=script&lang=js"
export * from "./JwJiaocaiOrderSelectJc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports